module.exports = __webpack_public_path__ + "img/avatar.ef434da5.png";